/**
 * Strip internal assistant metadata appended to persisted user messages
 * (legacy clarification payloads shown in older conversations).
 */
export function sanitizeMessageContent(content) {
  if (typeof content !== 'string') {
    return content
  }
  return content
    .replace(/\n\n\[(Clarification choice|User selected table context):[\s\S]*$/u, '')
    .trim()
}
